<template>
  <div :class="{ 'content-block': !previewModeOnly }">
    <h2 v-if="!previewModeOnly" class="mb-4">Lease Periods</h2>
    <p v-if="!previewModeOnly">
      {{ description }}
    </p>

    <LeasePeriodsFilters class="mb-4" :lease-period-filters="filters" :semesters="semesters" />

    <div v-if="isLeasePeriodLoading" style="width: 100%; justify-content: center; display: flex;">
      <v-progress-circular indeterminate color="primary"/>
    </div>
    <LeasePeriodListItem
      v-for="leasePeriod in leasePeriodsFiltered"
      :key="leasePeriod.id"
      class="mb-4"
      :lease-period="leasePeriod"
      @apply="checkAvailability"
    />
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Ref } from "vue-facing-decorator";
import { Property } from "../../../middleware/Property";
import { Swiper as VueSwiper, SwiperSlide } from "swiper/vue";
import { authService } from "../../../services/authServiceInstance";
import { LeasePeriod } from "../../../middleware/LeasePeriod";
import LeasePeriodListItem from "./LeasePeriodListItem.vue";
import LeasePeriodsFilters from "./LeasePeriodsFilters.vue";
import { LeasePeriodFilters } from "./LeasePreiodTypes";
import { LeasePeriodSemester } from "../../../middleware/LeasePeriodSemester";

// @deprecated
@Component({
  components: {
    LeasePeriodsFilters,
    LeasePeriodListItem,
    VueSwiper,
    SwiperSlide,
  },
})
export default class PropertyLeasePeriods extends Vue {
  @Prop({ type: Property }) property: Property;
  @Prop({ type: String }) description: string;
  @Prop({ type: Boolean }) previewModeOnly: boolean;

  @Ref() vueSwiper: any; // really VueSwiper, but gives TS error

  leasePeriods: LeasePeriod[] = [];
  currentSlide = 1;
  selectedPeriod = null;
  selectedRoomType = null;
  isLeasePeriodLoading = true;

  filters = {
    semesterId: null,
    gender: null,
    roomType: null,
    sortBy: "asc",
  } as LeasePeriodFilters;

  get leasePeriodsFiltered() {
    let result = this.leasePeriods;
    if (this.filters.semesterId !== null) {
      result = result.filter((leasePeriod) =>
        leasePeriod.semesters.some((semester) => semester.id === this.filters.semesterId)
      );
    }
    if (this.filters.gender !== null) {
      result = result.filter((leasePeriod) => leasePeriod.genders_available.includes(this.filters.gender));
    }
    if (this.filters.roomType !== null) {
      // TODO
      // result.filter(leasePeriod => leasePeriod.genders_available.includes(this.filters.gender))
    }
    if (this.filters.sortBy !== null) {
      result = [...result].sort((a, b) => (new Date(a.start_date) > new Date(b.start_date) ? 1 : -1));
      if (this.filters.sortBy === "asc") {
        result.reverse();
      }
    }
    return result;
  }

  get semesters() {
    const semesterById: Record<string, LeasePeriodSemester> = {};
    this.leasePeriods.forEach((leasePeriod) => {
      leasePeriod.semesters.forEach((semester) => {
        semesterById[semester.id] = semester;
      });
    });
    return Object.values(semesterById);
  }

  checkAvailability(leasePeriodId: number) {
    if (authService.hasRole("student")) return;

    const leasePeriod = this.leasePeriods.find((leasePeriod) => leasePeriod.id === leasePeriodId);

    if (leasePeriod.open_to_renewals || leasePeriod.allow_same_bed_renewals) {
      this.$store.dispatch("ui/toggleAuthModal", {
        open: true,
        type: "login",
        data: {},
      });
    } else {
      this.$store.dispatch("ui/toggleAuthModal", {
        open: true,
        type: 'signup',
        data: {
          agreement_period: leasePeriodId,
          start_date: leasePeriod.start_date,
          end_date: leasePeriod.end_date,
        },
      });
    }
  }

  async mounted() {
    // await this.$api.semester.get()

    try {
      const leasePeriods = await this.$api.leasePeriod.getOpenForProperty(this.property.id);

      this.leasePeriods = leasePeriods.filter(({ visible }) => visible);
      this.isLeasePeriodLoading = false
    } catch (e) {
      await this.$store.dispatch("ui/showError", "Couldn't load lease periods");
    }
  }
}
</script>

<style lang="scss"></style>
